import React, { useEffect } from 'react';
import AppDownloadBanner from './AppDownloadBanner';
import HeroSectionV2 from './HeroSectionV2';
import TrustBarSection from './TrustBarSection';
import AIFeaturesSection from './AIFeaturesSection';
import HowItWorksAnimated from './HowItWorksAnimated';
import StudyPlanSection from './StudyPlanSection';
import CustomQuizSection from './CustomQuizSection';
import PYQSection from './PYQSection';
import MockTestSection from './MockTestSection';
import ReportCardSection from './ReportCardSection';
import SuccessMetricsWall from './SuccessMetricsWall';
import AITechnologyShowcase from './AITechnologyShowcase';
import TestimonialsV2 from './TestimonialsV2';
import PricingTeaser from './PricingTeaser';
import './home-v2.css';

/**
 * HomeV2 - Modern Redesigned Landing Page for WiziAI
 * 
 * This is a complete redesign of the home page with modern aesthetics,
 * AI-powered theme, and professional layout. Features include:
 * - Split-screen hero with gradient backgrounds
 * - Glassmorphism effects and modern cards
 * - Animated counters and scroll effects
 * - AI technology showcase
 * - Success stories and testimonials
 * - Pricing teaser
 * 
 * IMPORTANT: All image placeholders need to be replaced with actual AI-generated images.
 * See HOME_V2_README.md for all image prompts and setup instructions.
 */

const HomeV2: React.FC = () => {
  useEffect(() => {
    // Add WOW.js or similar animation library initialization if needed
    document.title = 'WiziAI - AI-Powered JEE & NEET Preparation Platform';
  }, []);

  return (
    <div className="home-v2">
      {/* App Download Banner - Prominent download CTA */}
      <AppDownloadBanner />
      
      {/* Hero Section - Split screen with AI image */}
      <HeroSectionV2 />

      {/* Trust Bar - Key metrics strip */}
      <TrustBarSection />

      {/* AI-Powered Features - Interactive feature cards */}
      <AIFeaturesSection />

      {/* How It Works - Animated timeline */}
      <HowItWorksAnimated />

      {/* Study Plan Section - AI-powered personalized planning */}
      <StudyPlanSection />

      {/* Feature Showcases - Highlight platform benefits */}
      <CustomQuizSection />
      <PYQSection />
      <MockTestSection />
      <ReportCardSection />

      {/* Success Metrics - Animated numbers wall */}
      <SuccessMetricsWall />

      {/* AI Technology Showcase - Neural network visual */}
      <AITechnologyShowcase />

      {/* Testimonials - Success stories */}
      <TestimonialsV2 />

      {/* Pricing Teaser - Plan comparison */}
      <PricingTeaser />

      {/* FAQ Section - Keep existing or add new one */}
      {/* Can import FAQSection from old home if needed */}
    </div>
  );
};

export default HomeV2;
